import { render, staticRenderFns } from "./SvgInstagram.vue?vue&type=template&id=3d2b3486"
import script from "./SvgInstagram.vue?vue&type=script&setup=true&lang=ts"
export * from "./SvgInstagram.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports